import { createRoot } from "react-dom/client";
import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store/store";
import App from "./App";
import i18n from "./i18n";

import "./resources/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/themes/md-light-indigo/theme.css";
// import "primereact/resources/themes/lara-light-green/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "react-toastify/dist/ReactToastify.css";
import "./resources/customToast.css";
import "react-image-gallery/styles/css/image-gallery.css";

const container = document.getElementById("root");
const root = createRoot(container);

// i18n.changeLanguage("en");

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </PersistGate>
  </Provider>
);
